// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-Table-BaseTable-EditableCell-EditableCell-module__display";
var _2 = "webpack-concepts-Extraction-Blocks-Table-BaseTable-EditableCell-EditableCell-module__label";
var _3 = "webpack-concepts-Extraction-Blocks-Table-BaseTable-EditableCell-EditableCell-module__textArea";
export { _1 as "display", _2 as "label", _3 as "textArea" }
